import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { apiClient } from "~/lib/api";
import { FeedbackDetail } from "~/components/FeedbackDetail";
import { Button } from "~/components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function FeedbackDetailPage() {
  const { id } = useParams<{ id: string }>();
  const [feedback, setFeedback] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;

    const fetchFeedback = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await apiClient.getFeedback(id);
        setFeedback(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load feedback');
      } finally {
        setLoading(false);
      }
    };

    fetchFeedback();
  }, [id]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div>Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-red-600">Error: {error}</div>
      </div>
    );
  }

  if (!feedback) {
    return null;
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="sm" className="gap-2" asChild>
          <Link to="/">
            <ArrowLeft className="h-4 w-4" />
            Back to Feedback
          </Link>
        </Button>
      </div>

      <FeedbackDetail feedback={feedback} />
    </div>
  );
}
